/**
 * ---------- @REACTIMPORT
 */
import React, { useEffect } from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom'
import { HelmetProvider } from 'react-helmet-async'
import { Analytics } from '@vercel/analytics/react'
/**
 * ---------- @PAGESandSTYLESIMPORT
 */
import Home from './pages/index'
import Navigation from './components/Navigation'
import Produits from './pages/produits'
import ProduitsId from './pages/produitsid'
import DevisPage from './pages/devis'
import ContactPage from './pages/contact'
import PourquoiNous from './pages/pourquoi-nous'
import Footer from './components/Footer'
import Error from './pages/error'
import GlobalStyle from './utils/style/GlobalStyle'
import './utils/style/animation.css'
import DevisGenerator from './pages/DevisGenerator'
import Admin from './pages/admin'
import SuiviDevis from './pages/suivi-devis'
import FeedbackPopup from './components/FeedbackPopup'
import BannerFourrage from './components/BannerFourrage'

function ScrollToTop() {
  const { pathname } = useLocation()
  useEffect(() => { window.scrollTo(0, 0) }, [pathname])
  return null
}

// L'admin a sa propre coque plein écran : pas de nav, bandeau ni footer publics.
const isAdmin = (pathname) => pathname.startsWith('/admin')

function PublicHeader() {
  const { pathname } = useLocation()
  if (isAdmin(pathname)) return null
  return <><BannerFourrage /><Navigation /></>
}

function PublicFooter() {
  const { pathname } = useLocation()
  if (isAdmin(pathname)) return null
  return <><Footer /><FeedbackPopup /></>
}


const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <Analytics />
      <Router>
        <ScrollToTop />
        <GlobalStyle />
        <PublicHeader />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/produits" element={<Produits />} />
          <Route path="/produits/:id" element={<ProduitsId />} />
          <Route path="/devis" element={<DevisPage />} />
          <Route path="*" element={<Error />} />
          <Route path="/pourquoi-nous" element={<PourquoiNous />} />
          <Route path="/devis-generator" element={<DevisGenerator />} />
          <Route path="/admin/*" element={<Admin />} />
          <Route path="/suivi-devis" element={<SuiviDevis />} />
        </Routes>
        <PublicFooter />
      </Router>
    </HelmetProvider>
  </React.StrictMode>,
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals()
